import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Comparison } from '../components/Comparison';
import { Requirements } from '../components/Requirements';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen" data-id="element-238">
      <Navigation data-id="element-239" />
      <Hero data-id="element-240" />
      <About data-id="element-241" />
      <Services data-id="element-242" />
      <Comparison data-id="element-243" />
      <Requirements data-id="element-244" />
      <ContactForm data-id="element-245" />
      <Footer data-id="element-246" />
    </div>;
}